import {isNotNil} from 'ramda';

import {UnifiedAlbumImage} from '../types/UnifiedAlbumImage';

/** Promo, campaign and financing placeholder tiles: advertisement inserts, not album photos. */
export const isPromoTileImage = (image: UnifiedAlbumImage) =>
  image.isPromoPhoto || image.isCampaignPhoto === true || isNotNil(image.financingPlaceholder);
